
import { Component, Prop, Vue } from "vue-property-decorator";
import { Candidate, CandidateResult, Answer } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";
import DialogDVF from "./dialog-dvf.vue";
import BtnBase from "./btn-base.vue";

@Component({ components: { DescribeData, DialogDVF, BtnBase } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: Answer, default: () => new Answer() }) mindData!: Answer;
  @Prop({ default: false }) pdfIng!: boolean;
  // @Prop() show!: Function;
  @Prop({ type: CandidateResult, default: () => new CandidateResult() })
  // all!: CandidateResult; //候选人信息 所有表
  @Prop({ type: Candidate, default: () => new Candidate() })
  // candidate!: CandidateResult; //候选人信息 主表
  visibleForDVF = false; // 阅读指引弹窗是否显示
  // 心理健康等级
  get minDataLevel(): object {
    const score = this.mindData.psycResult.newResultList[0].isMatch;
    if (score === 2) {
      return {
        text: "高风险",
        color: "#F72D20"
      };
    } else if (score === 1) {
      return {
        text: "中风险",
        color: "#FF9B00"
      };
    } else if (score === 0) {
      return {
        text: "低风险",
        color: "#19C976 "
      };
    } else {
      return {};
    }
  }
}
